<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg"  style="background-image: url(static/video/banner.jpg);">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        <!-- 视频资料 -->
                         {{ $t('resource.resource_video_banner_title') }}
                    </h1>
                    <h3>
                        <!-- 奥太电气视频资源 -->
                         {{ $t('resource.resource_video_banner_subtitle') }}
                    </h3>
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                            <!-- 首页 -->
                             {{ $t('resource.resource_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item >
                            <!-- 视频资料 -->
                             {{ $t('resource.resource_breadcrumb_video') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
      

          <!-- 菜单 -->
         <!-- <section class="menu_common" >
            <div class="container" >
                <div class="menu_row tab-buttons">
                    <div class="menu_li">
                            <div class="menu_li_title " :class="videoType == 'publicize' ? 'active-btn' : ''"  @click="handleReplace('publicize')">宣传视频</div>
                    </div>
                    <div  class="menu_li" >
                        <div  class="menu_li_title" :class="videoType == 'industry' ? 'active-btn' : ''"  @click="handleReplace('industry')" >行业视频</div>
                    </div>
                </div>
            </div>
          
        </section> -->

        <!-- 内容 -->
        <section class="blog-one">
            <div class="container">
                <div class="row">
                    <div class="col-xl-4 col-lg-4 wow fadeInUp" v-for="(item,index) in list" :key="index" :data-wow-delay="(index+1)*100+'ms'">
                        <div class="blog-one__single" @click="handleDetail(item)">
                            <div class="blog-one__img">
                                <img :src="item.imgUrl" alt="" style="width: 370px; height: 250px;">
                                <!-- <div class="blog-one__tag">
                                    <p>{{ item.typeName }}</p>
                                </div> -->
                                <a>
                                    <i style="color: var(--notech-white);" class="el-icon-video-play"></i>
                                </a>
                            </div>
                            <div class="blog-one__content">
                                <!-- <ul class="list-unstyled blog-one__meta">
                                    <li><a><i class="far fa-clock"></i>{{ item.time }}</a>
                                    </li>
                                </ul> -->
                                <h3 class="blog-one__title">
                                    <a>
                                        {{ item.name }}
                                        <!-- {{ $t(`resource.${item.i18n_name}`) }} -->
                                    </a>
                                </h3>
                                <!-- <div class="blog-one__bottom">
                                    <a >查看详情<i class="fa fa-long-arrow-alt-right"></i></a>
                                </div> -->
                            </div>
                        </div>
                    </div>

                     <!-- <div style="width: 1200px; height: 600px;">
                                            <iframe src="//player.bilibili.com/player.html?isOutside=true&aid=115024592901749&bvid=BV1eNbzzWEBF&cid=31679841705&p=1" 
                                                scrolling="no" 
                                                border="0" 
                                                frameborder="no" 
                                                framespacing="0" 
                                                width="100%"
                                                height="100%"
                                                sandbox="allow-top-navigation allow-same-origin allow-forms allow-scripts"    

                                                allowfullscreen="allowfullscreen"
                                                id="iframe_div"

                                            ></iframe>


                                           <iframe src="//player.bilibili.com/player.html?bvid=BV1dxeTz7EKL&page=1" scrolling="no" border="0" frameborder="no" framespacing="0" allowfullscreen="true"> </iframe>
                    </div> -->



                        
                    <div class="col-lg-12">
                            <div  class="blog-pagination justify-content-center">
                            <el-pagination
                                background
                                layout="prev, pager, next"
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="queryParam.pageNum"
                                :page-sizes="[9, 18, 27, 36]"
                                :page-size="queryParam.pageSize"
                            
                                :total="total"
                            >
                            </el-pagination>
                        </div>
                        <!-- /.blog-pagination -->
                    </div>
                </div>

            </div>
        </section>

        <div v-if="dialogVisible">
            <el-dialog  :visible.sync="dialogVisible" @closed="handleClose" >
                <video style="width: calc(46vw);" ref="videoPlayer" :playsinline="true" autoplay="autoplay" loop="loop" :src="videoSrc" controls=""></video>
                 <!-- <iframe 
                    :src="videoSrc" 
                    scrolling="no" 
                    border="0" 
                    frameborder="no" 
                    framespacing="0" 
                    width="100%"
                    height="100%"
                    sandbox="allow-top-navigation allow-same-origin allow-forms allow-scripts"    

                    allowfullscreen="allowfullscreen"
                    id="iframe_div"

                ></iframe> -->

            </el-dialog>
        </div>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'video',
    mixins: [MixinsList],
    data () {
        return {
            list: [],
            typeIndex: 0,
            queryParam: {
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            dialogVisible: false,
            videoSrc: "",
            videoType: "publicize",  // 视频类型 publicize-宣传  industry--行业
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.video_li').addClass('current');
    },
    methods: {
        handleSizeChange(i, j) {
            Object.assign(this.queryParam, { pageSize: i })
            this.getList()
        },
        handleCurrentChange(i, j) {
            Object.assign(this.queryParam, { pageNum: i })
            this.getList()
        },

        handleReplace(value) {
            this.videoType = value
            this.queryParam.pageNum = 1
            this.getList()
        },
        // 获取内容
        async getList() {
            this.list = []
            // const { result } = res
            // var arr = JSON.parse(JSON.stringify(result[this.videoType]))  
           
            // this.total = arr.length
            // var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            // this.list = arr.splice(p,this.queryParam.pageSize)

            try {
            const  result  = await loadData('video', this.lang)
            console.log("result",result)
            var arr = JSON.parse(JSON.stringify(result[this.videoType]))  
            this.total = arr.length
            var p = (this.queryParam.pageNum-1)*this.queryParam.pageSize
            this.list = arr.splice(p,this.queryParam.pageSize)
            } catch (error) {
                console.log("error",error)
            }
        },
        // 详情页面
        handleDetail(item) {
            // videoDetail
            // this.$router.push({
            //     path: "videoDetail",
            //     query: {
            //         title: item.title,
            //         time: item.time,
            //         typeName: item.typeName
            //     }
            // });
            this.videoSrc = item.downUrl
            this.dialogVisible = true
            console.log("查看视频")
        },
        // 关闭视频
        handleClose() {
            let myPlayer = this.$refs.videoPlayer.player;
            myPlayer.pause()
            this.dialogVisible = false
        }
    }
}
</script>
<style scoped>
.page-header-bg {
    background-color: transparent; 
}
/* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}

.page-header__inner h1 {
    font-size: var(--font-size-40);
}

.he_plnavul {
    position: relative;
    z-index: 100;
}
.he_common {
    width: 1400px;
    margin: auto;
}
 .he_plnavli {
    display: inline-block;
    display: inline-block;
    margin-right: 98px;

    margin-right: 0px;
    position: relative;
 }
.he_plnavli:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 2px;
    height: 20px;
    background: #eeeeee;
    transition: all 0.36s;
}

 .he_plnavli a {
    padding: 0 40px;
    position: relative;
    font-size: var(--font-size-16);
    line-height: 78px;
    color: var(--notech-gray);
    transition: all 0.36s ease;
    position: relative;
    display: block;
 }

.he_plnavli a {
    cursor: pointer;
    line-height: 38px;
}
.he_plnavli.yxnav_active2::after {
    background: var(--notech-base);
}
.yxnav_active2 a {
    background-color: var(--notech-base);
    color: var(--notech-white);
 }

 .yxnav_active2 a:hover {
    color: var(--notech-white);
 }
/*  */
.he_plucnav {
    padding: 31px 0;
    z-index: 110 !important;
}
.he_plucnav {
    z-index: 89;
}
.he_plucnav {
    width: 100%;
    box-shadow: 0 5px 70px 0 rgba(63, 101, 171, 0.1);
    background: #fff;
    position: relative;
    z-index: 10;
    top: 86px;
    transition: all 0.36s;
    position: static;
}
.blog-one__single {
    cursor: pointer;
}
.blog-one__content {
    padding: 30px 20px 29px;
}
.blog-one__title {
    height: 91px;
    overflow:hidden; /* 溢出的内容隐藏 */
    text-overflow:ellipsis; /*  溢出的部分用省略号...显示 */
    display:-webkit-box; /* 将对象作为弹性伸缩盒子模型显示  */
    -webkit-line-clamp:3; /* 行数 */
    -webkit-box-orient:vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
}


::v-deep .el-dialog {
    box-shadow: none;
		background: transparent;

	}
    ::v-deep .el-dialog__headerbtn .el-dialog__close {
		color: var(--notech-white) !important;
        font-size: 25px;
	}

    ::v-deep  .el-dialog__body  {
        width: calc(48vw);
        height: 600px;
    }



    
.menu_common {
    width: 100%;
    box-shadow: 0 5px 70px 0 rgba(63, 101, 171, 0.1);
    background: #fff;
}
.menu_row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}
.menu_li {
    width: 25%;
    padding: 10px;
}
.menu_li_title {
    cursor: pointer;
    border: 1px solid var(--notech-bdr-color);
    /* font-size: var(--font-size-20); */
    font-size: 14px;
    font-weight: 700;
    padding: 10px 0px;
    text-align: center;
}
.active-btn {
    background-color: var(--notech-base);
    color: var(--notech-white);
}


</style> 
